import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function PriceAlert() {
  return <motion.div initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="sticky top-0 z-50 w-full overflow-hidden" data-id="element-457">
      {/* Main Banner */}
      <div className="relative bg-gradient-to-r from-gold-dark via-gold to-gold-light shadow-2xl" data-id="element-458">
        {/* Animated shine effect */}
        <motion.div animate={{
        x: ['-100%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear',
        repeatDelay: 1
      }} className="absolute inset-0 w-1/3 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" data-id="element-459" />

        {/* Content Container */}
        <div className="relative py-3 md:py-4 px-4" data-id="element-460">
          <div className="max-w-7xl mx-auto" data-id="element-461">
            <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-462">
              <div className="flex items-center gap-2 md:gap-3" data-id="element-463">
                <motion.div animate={{
                scale: [1, 1.15, 1]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="flex-shrink-0" data-id="element-464">
                  <div className="relative" data-id="element-465">
                    <div className="absolute inset-0 bg-navy/20 rounded-full blur-md" data-id="element-466" />
                    <AlertCircleIcon className="relative h-5 w-5 md:h-6 md:w-6 text-navy" aria-hidden="true" data-id="element-467" />
                  </div>
                </motion.div>

                <p className="font-heading font-black text-sm md:text-lg text-navy leading-tight" data-id="element-468">
                  <span className="hidden md:inline" data-id="element-469">⚡ </span>
                  PRECIO DE LANZAMIENTO:{' '}
                  <span className="text-navy-dark" data-id="element-470">$27</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom decorative border */}
        <div className="h-1 bg-gradient-to-r from-navy-dark via-navy to-navy-dark" data-id="element-471" />
      </div>
    </motion.div>;
}